module.exports = __webpack_public_path__ + "img/product-packaging-mes.5b4e0869.png";